import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShield, faClock } from '@fortawesome/free-solid-svg-icons';

export function StoragePoliciesPage() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-semibold text-foreground">Storage Policies</h1>
        <p className="mt-0.5 text-sm text-muted-foreground">
          Per-module asset class rules: size limits, MIME types, counts, and lifecycle
        </p>
      </div>

      <div className="flex flex-col items-center justify-center rounded-xl border border-border bg-card py-20 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-muted">
          <FontAwesomeIcon icon={faShield} className="h-6 w-6 text-muted-foreground" />
        </div>
        <h2 className="mt-4 text-base font-semibold text-foreground">Storage Policies</h2>
        <p className="mt-2 max-w-sm text-sm text-muted-foreground">
          Policy viewing and editing requires a backend management endpoint. Policies are seeded via
          database migrations and enforced by the AME policy engine.
        </p>
        <div className="mt-6 flex items-center gap-2 rounded-full border border-border px-4 py-2 text-xs text-muted-foreground">
          <FontAwesomeIcon icon={faClock} className="h-3.5 w-3.5" />
          Policy management API planned for a future release
        </div>
      </div>

      <div className="rounded-xl border border-border bg-card p-5">
        <h3 className="mb-4 text-sm font-semibold text-foreground">
          Seeded Policies (inspection module)
        </h3>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-border text-sm">
            <thead>
              <tr className="bg-muted/40">
                <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">
                  Module
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">
                  Class
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">
                  Max Size
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">
                  Max Count
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">
                  Versions
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">
                  Quarantine (days)
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {[
                {
                  module: 'inspection',
                  cls: 'photo',
                  size: '50 MB',
                  count: 6,
                  versions: 3,
                  quarantine: 7,
                },
                {
                  module: 'inspection',
                  cls: 'video',
                  size: '200 MB',
                  count: 1,
                  versions: 1,
                  quarantine: 7,
                },
                {
                  module: 'inspection',
                  cls: 'document',
                  size: '25 MB',
                  count: 2,
                  versions: 2,
                  quarantine: 7,
                },
                {
                  module: 'inspection',
                  cls: 'thumbnail',
                  size: '2 MB',
                  count: 6,
                  versions: 3,
                  quarantine: 7,
                },
              ].map((row) => (
                <tr
                  key={`${row.module}-${row.cls}`}
                  className="hover:bg-muted/30 transition-colors"
                >
                  <td className="px-4 py-3 text-sm text-foreground">{row.module}</td>
                  <td className="px-4 py-3 text-sm text-muted-foreground">{row.cls}</td>
                  <td className="px-4 py-3 text-sm text-muted-foreground">{row.size}</td>
                  <td className="px-4 py-3 text-sm text-muted-foreground">{row.count}</td>
                  <td className="px-4 py-3 text-sm text-muted-foreground">{row.versions}</td>
                  <td className="px-4 py-3 text-sm text-muted-foreground">{row.quarantine}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-3 text-xs text-muted-foreground">
          Additional policies will appear here once a policy management API is available.
        </p>
      </div>
    </div>
  );
}
